/**
 * Converts a 2D array of strings into a valid CSV string.
 * Cells are quoted and internal double-quotes are escaped.
 */
function buildCsvString(headers: string[], rows: string[][]): string {
  const escape = (value: string) =>
    `"${String(value ?? "").replace(/"/g, '""')}"`

  return [[...headers], ...rows]
    .map((row) => row.map(escape).join(","))
    .join("\n")
}

/**
 * Triggers a browser download of the given CSV data.
 *
 * @param headers - Column header labels
 * @param rows - Data rows; each inner array must match the header count
 * @param filename - Downloaded filename, e.g. "dues-invoices.csv"
 */
export function downloadCsv(
  headers: string[],
  rows: string[][],
  filename: string
): void {
  const csvString = buildCsvString(headers, rows)
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
